import { render, staticRenderFns } from "./AttachRecipe.vue?vue&type=template&id=5044a209&"
import script from "./AttachRecipe.vue?vue&type=script&lang=js&"
export * from "./AttachRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports